// extracted by mini-css-extract-plugin
export default {"rankingDropdown":"_2Gj3","name":"_1wTM","degree":"_1mzB","time":"_3VVM"};